module.exports = __webpack_public_path__ + "img/signal_wifi_4_bar-blue.ce584659.svg";